import React from 'react'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import ResponsiveTable from '../components/ResponsiveTable'
import Button from '../elements/Button'
import globals from '../globals'
import AjaxLoaderImg from '../components/AjaxLoaderImg'
import { connect } from 'react-redux'


class ManageInternationalCalls extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            data: [],
            errors: [],
            isLoading: []
        }
    }

    componentDidMount () {
        DataSource.getData(`/api/getInternationalCallDestinations/${this.props.serviceId}`, result => {
            this.setState({
                data: [...result],
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    async handleToggleAccess (event, item, key) {
        event.preventDefault()
        this.setState({ isLoading: [...this.state.isLoading, key] })
        const data = {
            prefix: item.prefix,
            enabled: !item.enabled,
            serviceId: this.props.serviceId
        }

        await DataSource.postData('/api/postToggleInternationalCall', data, response => {
            this.stopLoading(key)
            this.handleSuccess(key)
        }, response => {
            globals.handleError(response)
            this.stopLoading(key)
            this.handleFailure(key)
        })

    }

    handleSuccess (key) {
        const data = [...this.state.data]
        data[key].enabled = !this.state.data[key].enabled
        this.setState({ data: data })
    }

    handleFailure (key) {
        this.setState({ errors: [...this.state.errors, key] })

        setTimeout(() => {
            const errors = []
            this.state.errors.forEach(item => {
                if (item !== key) {
                    errors.push(item)
                }
            })
            this.setState({ errors: errors })
        }, 8000)
    }

    stopLoading (key) {
        const isLoading = []
        this.state.isLoading.forEach(item => {
            if (item !== key) {
                isLoading.push(item)
            }
        })
        this.setState({ isLoading: isLoading })
    }

    render () {
        const Switch = (item, key) => {
            if (this.state.errors.includes(key)) {
                return <small>An error occurred.<br />Please try again shortly.</small>
            } else if (this.state.isLoading.includes(key)) {
                return <AjaxLoaderImg width='35px' />
            } else {
                return (
                    <Button
                        title={item.enabled ? 'Enabled' : 'Disabled'}
                        className={item.enabled ? '' : 'btn-danger'}
                        action={event => this.handleToggleAccess(event, item, key)}
                    />
                )
            }
        }

        const headings = ['Destination', 'Country Code +', 'Access']
        const rows = this.state.data.map((item, key) => {
            return [
                item.country,
                item.prefix,
                Switch(item, key)
            ]
        })

        return (
            <div>
                <div className='manage-international-calls module'>
                    <Heading title={this.props.title} />
                    <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                        <div className='row'>
                            <div className='col-12 col-md-10 offset-md-1'>
                                <p className='bold'>Fraud-risk call destinations</p>
                                <p>Some international call destinations are frequently used for phone fraud. Exetel has a policy of de-activating these destinations to protect you from fraudulent phone use and charges. Your Exetel Home Phone service is blocked from making calls to fraud-risk international call destinations by default.</p>
                                <p className='bold'>How can I make calls to fraud-risk countries?</p>
                                <p>You will need to unlock the specific international destination you wish to call below. For your security, unlocking a destination requires a 2-step verification process.</p>
                                <p>Once you have submitted your change below you will have immediate access to calls to the destination you have unlocked. 
                                </p>
                                <p className='bold'>Unlock high-risk destinations below</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2'>
                                <ResponsiveTable data={{ headings: headings, rows: rows }} />
                            </div>
                        </div>
                    </ModuleWithLoader>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    isVerified: state.verifiedUser.isVerified,
    verifiedToken: state.verifiedUser.verifiedToken
})

export default connect(mapStateToProps)(ManageInternationalCalls)



// WEBPACK FOOTER //
// ./resources/js/modules/ManageInternationalCalls.js